import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { LucideAngularModule, LayoutDashboard, Settings } from 'lucide-angular';

@Component({
  selector: 'sh-mode-toggle',
  imports: [LucideAngularModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'role': 'switch',
    '[attr.aria-checked]': 'isSettingsMode()',
    '[attr.aria-label]': '"Switch between Operations and Settings"',
    'tabindex': '0',
    '(click)': 'toggle()',
    '(keydown)': 'onKeydown($event)',
  },
  template: `
    <div class="toggle-track">
      <div
        class="toggle-option"
        [class.toggle-option--active]="!isSettingsMode()"
        title="Operations">
        <lucide-angular [img]="dashboardIcon" [size]="14"></lucide-angular>
      </div>
      <div
        class="toggle-option"
        [class.toggle-option--active]="isSettingsMode()"
        title="Settings">
        <lucide-angular [img]="settingsIcon" [size]="14"></lucide-angular>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: inline-flex;
      cursor: pointer;
      outline: none;
      border-radius: 9999px;
    }

    :host:focus-visible {
      outline: 2px solid var(--color-brand-primary);
      outline-offset: 2px;
    }

    .toggle-track {
      display: flex;
      align-items: center;
      border-radius: 9999px;
      padding: 3px;
      background: var(--color-surface-hover);
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
      transition: background-color 200ms ease;
    }

    .toggle-option {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      border-radius: 9999px;
      color: var(--color-text-muted);
      transition: all 250ms ease;
    }

    .toggle-option:hover:not(.toggle-option--active) {
      color: var(--color-text-primary);
    }

    .toggle-option--active {
      background: var(--color-brand-primary);
      color: var(--color-brand-primary-contrast);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
  `],
})
export class ModeToggleComponent {
  readonly isSettingsMode = input(false);
  readonly modeChanged = output<boolean>();

  protected readonly dashboardIcon = LayoutDashboard;
  protected readonly settingsIcon = Settings;

  protected toggle(): void {
    this.modeChanged.emit(!this.isSettingsMode());
  }

  protected onKeydown(e: KeyboardEvent): void {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.toggle();
    }
  }
}
